import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    setCalculationValue: (field: string, value: string) => void;
    cementplateLength: string;
    cementplateWidth: string;
    cementplateThickness: string;
};

const Calculation = ({
    setCalculationValue,
    cementplateLength,
    cementplateWidth,
    cementplateThickness
}: Props) => {
    const { t } = useGranite();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col>
                    <h3 className="d-sm-block">
                        {t(
                            "calculator.cementplateCalculator.cementplateMeasurements"
                        )}
                    </h3>
                </Col>
            </Row>
            <Row>
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementplateLength"}
                    dimension={"length"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    value={cementplateLength}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementplateWidth"}
                    dimension={"width"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    value={cementplateWidth}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementplateThickness"}
                    dimension={"thickness"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    value={cementplateThickness}
                />
            </Row>
        </div>
    );
};

export default Calculation;
